import { SiteControlLayout } from '@scaleaq/sitecontrol-lib';

import { getConstrainedWidget } from '@/pages/landingPage/grid/getConstrainedWidget.ts';

export const doLayoutWidgetsFitInViewport = (
  layout: SiteControlLayout,
  numColumns: number,
  enablePreviewContent?: boolean
): boolean => {
  if (numColumns < 1) return false;

  const widgets = layout.widgets;
  if (widgets.length === 0) return true;

  const overlaps = (a: { y: number; h: number }, b: { y: number; h: number }) =>
    a.y < b.y + b.h && b.y < a.y + a.h;

  const sorted = [...widgets].sort((a, b) => {
    const ya = a.y ?? 0,
      yb = b.y ?? 0;
    if (ya !== yb) return ya - yb;
    return (a.x ?? 0) - (b.x ?? 0);
  });

  const groups: (typeof widgets)[] = [];
  for (const w of sorted) {
    const y = w.y ?? 0,
      h = w.h ?? 1;
    const last = groups[groups.length - 1];
    const lastWidget = last?.[0];
    if (last && lastWidget && overlaps({ y: lastWidget.y ?? 0, h: lastWidget.h ?? 1 }, { y, h })) {
      last.push(w);
    } else {
      groups.push([w]);
    }
  }

  return groups.every(group =>
    group.every(widget => {
      const constrained = getConstrainedWidget({ widget, enablePreviewContent });
      const x = widget.x ?? 0;
      const y = widget.y ?? 0;
      const w_ = constrained.w ?? widget.w ?? 1;
      const h_ = constrained.h ?? widget.h ?? 1;
      return x >= 0 && y >= 0 && w_ >= 1 && h_ >= 1 && x + w_ <= numColumns;
    })
  );
};
